import { Component, OnInit } from '@angular/core';
import { AndroidPaymentSDK } from "./_helpers/AndroidPaymentSDK";
import { ToasterService } from "./_services/toaster.service";
import { ActivatedRoute } from "@angular/router";
declare var zE: any;

@Component({
  selector: 'bxl-mobile-test',
  templateUrl: 'mobile-test.component.html',
})
export class MobileTestComponent implements OnInit {
  initialized = false;
  data = "test";
  payment = new AndroidPaymentSDK();
  public serialNumber: string;

  constructor(private toaster: ToasterService, private route:ActivatedRoute) { }

  ngOnInit(): void {
    this.initialized = true;
    zE('webWidget', 'hide');

    this.route.queryParamMap.subscribe(paramMap => {

      this.serialNumber = paramMap.get('serial');;
    })

  }

  loadData() {
    this.data = "loaded";
  }


  public async processPayment() {
    this.toaster.spinnerDialog("Requesting Payment...", "Status").subscribe(async spinnerResult => {

      try {
        const result = await this.payment.collectPayment(2500, 'usd');
        this.data = 'Payment successful: ' + JSON.stringify(result);
        spinnerResult.close();


      } catch (error) {
        this.data = 'Payment failed: ' + JSON.stringify(error);
        spinnerResult.close();

      }
    });
  }

  public async connectToReader() {
    this.toaster.spinnerDialog("Connecting to reader...", "Status").subscribe(async spinnerResult => {
      try {
        const result = await this.payment.discoverReaders();
        this.data = 'Reader Found: ' + JSON.stringify(result);
        spinnerResult.close();

      } catch (error) {
        this.data = 'No Reader Found: ' + JSON.stringify(error);
        spinnerResult.close();
      }
    });
  }

  public async showQr() {
    try {
      const result = await this.payment.scanQRCode();
      this.data = 'Scan Success: ' + JSON.stringify(result);


    } catch (error) {
      this.data = 'Scan Failed: ' + JSON.stringify(error);
    }
    //(<any>window).AndroidPayment.showSettings();
  }

  public async showSettings() {
    this.payment.showSettings();
  }
}
